import { AppEntities } from "../../../config/entities";
import { NFLookupCatalog } from "./NFLookupCatalog";
import { NFLookupCatalogColumn } from "./NFLookupCatalogColumn";
import React from "react";

interface IProps {
  title?: string;
  fieldName: string;
  required?: boolean;
  showBorder?: boolean;
  width?: number;
  selectedCatalog?: boolean;
  setSelectedCatalog?: (value: boolean) => void;
  vendorId?: string;
}

export const NFLookupVendor = ({
  title,
  fieldName,
  required,
  showBorder,
  width,
  selectedCatalog,
  setSelectedCatalog,
  vendorId,
}: IProps) => {
  const loadData = async (searchText: string | undefined) => {
    return await AppEntities.VendorCustomer.getDataService().GetAll(
      searchText,
      vendorId
    );
  };

  return (
    <>
      <NFLookupCatalog
        fieldName={fieldName}
        title={title}
        entity={AppEntities.VendorCustomer}
        serverData={loadData}
        required={required}
        showBorder={showBorder}
        width={width}
        selectedCatalog={selectedCatalog}
        setSelectedCatalog={setSelectedCatalog}
      >
        <NFLookupCatalogColumn fieldName={"id"} caption={"Id"} />
        <NFLookupCatalogColumn fieldName={"name"} caption={"Name"} />
        <NFLookupCatalogColumn fieldName={"tin"} caption={"TIN"} />
      </NFLookupCatalog>
    </>
  );
};
